<div class="full-height layout-column overflow-x-auto-only">

  <!--Table Skeleton, shown only until the accounts have loaded for the first time-->
  <div *ngIf="!isInitialized" class="flex layout-column bringoz-table bringoz-table-skeleton fade-element-in-only">

    <div class="tr-header layout-row layout-align-start-center">
      <div class="th skeleton-col-lg"><div class="bringoz-skeleton bringoz-skeleton-text"></div></div>
      <div class="th skeleton-col-sm"><div class="bringoz-skeleton bringoz-skeleton-text"></div></div>
      <div class="th skeleton-col-sm"><div class="bringoz-skeleton bringoz-skeleton-text"></div></div>
      <div class="th skeleton-col-md"><div class="bringoz-skeleton bringoz-skeleton-text"></div></div>
      <div class="th skeleton-col-sm"><div class="bringoz-skeleton bringoz-skeleton-text"></div></div>
      <div class="th skeleton-col-sm"><div class="bringoz-skeleton bringoz-skeleton-text"></div></div>
      <div class="th skeleton-col-sm"><div class="bringoz-skeleton bringoz-skeleton-text"></div></div>
      <div class="th skeleton-col-md"><div class="bringoz-skeleton bringoz-skeleton-text"></div></div>
    </div>

    <div class="rows-container full-height layout-column">
      <div class="tr layout-row layout-align-start-center" *ngFor="let row of skeletonRows">
        <div class="td skeleton-col-lg layout-column">
          <div class="bringoz-skeleton bringoz-skeleton-text" style="width: 80%"></div>
          <div class="bringoz-skeleton bringoz-skeleton-text" style="width: 50%"></div>
        </div>
        <div class="td skeleton-col-sm">
          <div class="bringoz-skeleton bringoz-skeleton-text" style="width: 60%"></div>
        </div>
        <div class="td skeleton-col-sm">
          <div class="bringoz-skeleton bringoz-skeleton-text" style="width: 55%"></div>
        </div>
        <div class="td skeleton-col-md">
          <div class="bringoz-skeleton bringoz-skeleton-text" style="width: 75%"></div>
        </div>
        <div class="td skeleton-col-sm">
          <div class="bringoz-skeleton bringoz-skeleton-text" style="width: 45%"></div>
        </div>
        <div class="td skeleton-col-sm">
          <div class="bringoz-skeleton bringoz-skeleton-text" style="width: 65%"></div>
        </div>
        <div class="td skeleton-col-sm">
          <div class="bringoz-skeleton bringoz-skeleton-text" style="width: 50%"></div>
        </div>
        <div class="td skeleton-col-md">
          <div class="bringoz-skeleton bringoz-skeleton-text" style="width: 70%"></div>
        </div>
      </div>
    </div>

  </div>

  <div *ngIf="isInitialized" class="flex layout-column bringoz-table"
       [ngClass]="{'scrollable': isScrollable}">

    <div *ngIf="!displayAsItems" class="tr layout-row layout-align-start-center" id="header">
      <div class="th small flex-15">{{'Account Name' | translate}}</div>
      <div class="th small flex">{{'External ID' | translate}}</div>
      <div class="th small flex">{{'Account Type' | translate}}</div>
      <div class="th small flex">{{'Location' | translate}}</div>
      <div class="th small flex">{{'Shippers' | translate}}</div>
      <div class="th small flex">{{'Phone Number' | translate}}</div>
      <div class="th small flex">{{'Additional Phone Number' | translate}}</div>
      <div class="th small flex">{{'Branches' | translate}}</div>
      <div class="th small flex">{{'Category' | translate}}</div>
      <div class="th small flex">{{'Created On' | translate}}</div>
      <div class="th small flex">{{'Updated On' | translate}}</div>
    </div>

    <div class="full-height flex layout-column">
      <cdk-virtual-scroll-viewport [itemSize]="isScrollable ? 140 : 60" class="flex viewport" (scroll)="getNextBatch()">
        <ng-container *ngIf="!displayAsItems; else itemsContainer" class="flex layout-column">

          <app-demand-account-table-row *cdkVirtualFor="let account of accounts"
                                        [account]="account"
                                        class="item"
                                        (selectAccount)="onSelectAccount($event)">
          </app-demand-account-table-row>
        </ng-container>
        <ng-template #itemsContainer class="flex layout-column">

          <app-demand-account-item *cdkVirtualFor="let account of accounts"
                                   [account]="account"
                                   class="item"
                                   (selectAccount)="onSelectAccount($event)">
          </app-demand-account-item>
        </ng-template>

      </cdk-virtual-scroll-viewport>
    </div>

  </div>
</div>
